import { AssertionDescriptorUsageTypesEnum } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useZoneGetAssertionDescriptors = (
    usageTypeId: AssertionDescriptorUsageTypesEnum,
    checkForEditAccess?: boolean, enabled: boolean = true
) => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-assertion-descriptors-lookup', { usageTypeId, checkForEditAccess }],
        enabled,
        queryFn: async () => {
            const response = await zoneApiClient.getAssertionDescriptors(
                usageTypeId,
                undefined,
                checkForEditAccess
            );

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve assertion descriptors.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
